<script setup lang="ts">
import ConfirmOverlay from '~/components/app/ConfirmOverlay.vue'
import {
  DISCARD_UNSAVED_CANCEL_TEXT,
  DISCARD_UNSAVED_CONFIRM_TEXT,
  DISCARD_UNSAVED_DESCRIPTION,
  DISCARD_UNSAVED_TITLE,
} from '~/composables/ui/useDiscardUnsavedGuard'

defineProps<{
  show: boolean
}>()

const emit = defineEmits<{
  close: []
  confirm: []
}>()
</script>

<template>
  <ConfirmOverlay
    :show="show"
    :title="DISCARD_UNSAVED_TITLE"
    :description="DISCARD_UNSAVED_DESCRIPTION"
    :confirm-text="DISCARD_UNSAVED_CONFIRM_TEXT"
    :cancel-text="DISCARD_UNSAVED_CANCEL_TEXT"
    variant="warning"
    @close="emit('close')"
    @confirm="emit('confirm')"
  />
</template>
